export const STRIPE_LOGIN_URL = "https://dashboard.stripe.com/login"
